import { getJson } from '@rad/utility/http';
import { diffObjects } from '@rad/utility/json';
export const getAudit = (name, id) => getJson(`/api/audit/${name}/${id}`);
export const diffAuditTrail = (audits) => {
    const results = [];
    let previousState;
    for (const audit of audits) {
        const currentState = JSON.parse(audit.state_after_json);
        if (previousState) {
            const diff = diffObjects(previousState, currentState);
            results.push({
                'value': audit,
                'added': diff.added,
                'removed': diff.removed,
                'changed': diff.changed,
            });
        }
        else {
            const diff = diffObjects({}, currentState);
            results.push({
                'value': audit,
                'added': diff.added,
                'removed': [],
                'changed': [],
            });
        }
        previousState = currentState;
    }
    return results;
};
